import {
  API,
  BASE_URL_API_V1,
  axiosClient,
} from "../../../Constant/apiConstant";

export const getAllCustomersService = async (params) => {
  try {
    const res = await axiosClient.get(
      `${BASE_URL_API_V1}${API.V1.TEST_CUSTOMER}`,
      { params: params }
    );
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const addCustomerService = async (data) => {
  try {
    const res = await axiosClient.post(
      `${BASE_URL_API_V1}${API.V1.TEST_CUSTOMER}`,
      data
    );
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const editCustomerService = async (id, data) => {
  try {
    const res = await axiosClient.patch(
      `${BASE_URL_API_V1}${API.V1.TEST_CUSTOMER}/${id}`,
      data
    );
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteCusomerService = async (id) => {
  try {
    const res = await axiosClient.delete(
      `${BASE_URL_API_V1}${API.V1.TEST_CUSTOMER}/${id}`
    );
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
